import Link from 'next/link';
import { Search } from '@eqi-investimentos/icons/web';
import { Flex, IconButton } from '@eqi-investimentos/react';
import { PATHS } from '@/config/paths';
import { salesforceOpportunityConfig } from '@/config/salesForce';
import { useSendClickEvent } from '@/modules/Customer/http/client/mutations/useSendClickEvent';
import { useAuth } from '@/contexts/AuthContext';
import { NotificationsButton } from './NotificationsButton';
export const RightActions = () => {
  const {
    user
  } = useAuth();
  const unauthorized = !user?.name;
  const {
    mutate: sendClickEvent
  } = useSendClickEvent();
  const onClickLink = () => {
    if (unauthorized) {
      window.dispatchEvent(new Event('open-unauthenticated-modal'));
    }
    sendClickEvent({
      label: salesforceOpportunityConfig.sendClickEvent.search.label(window.location.pathname)
    });
  };
  return <Flex justifyContent="center" alignItems="center" gap="m" sx={{
    '& > a': {
      opacity: unauthorized ? 0.5 : 1
    }
  }} data-sentry-element="Flex" data-sentry-component="RightActions" data-sentry-source-file="index.tsx">
      <Link aria-label="button-go-to-search-screen" href={unauthorized ? '#' : PATHS?.search} data-sentry-element="Link" data-sentry-source-file="index.tsx">
        <IconButton aria-label="Pesquisar" icon={<Search color="content.primary" boxSize="1.5rem !important" />} variant="naked" onClick={e => {
        if (unauthorized) {
          e.stopPropagation();
        }
        onClickLink();
      }} data-sentry-element="IconButton" data-sentry-source-file="index.tsx" />
      </Link>
      <NotificationsButton data-sentry-element="NotificationsButton" data-sentry-source-file="index.tsx" />
    </Flex>;
};